var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00701 14.0867L5.55812 13.6984L6.14873 11.4943C5.25689 11.1658 4.43746 10.6876 3.72087 10.0903L2.10587 11.7053L1.04522 10.6446L2.66021 9.02964C1.76686 7.95797 1.14011 6.65624 0.881836 5.22638L2.3579 4.95801C2.92717 8.1097 5.68448 10.5003 9.00015 10.5003C12.3158 10.5003 15.0732 8.1097 15.6425 4.95801L17.1185 5.22638C16.8602 6.65624 16.2335 7.95797 15.3401 9.02964L16.9551 10.6446L15.8945 11.7053L14.2795 10.0903C13.5629 10.6876 12.7434 11.1658 11.8516 11.4943L12.4422 13.6984L10.9934 14.0867L10.4025 11.8816C9.94673 11.9597 9.4782 12.0003 9.00015 12.0003C8.52218 12.0003 8.05358 11.9597 7.59788 11.8816L7.00701 14.0867Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.3e3606458ef37893062dc991bdc45ba8.svg";
export { ForwardRef as ReactComponent };